<template>
  <el-dialog
    title="修改密码"
    width="398px"
    @open="open"
    :visible.sync="show"
    @close="cancel"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <section class="dialogContent">
      <p class="hint" v-show="checkWay">
        使用手机验证身份，现在手机：<span class="blue">
          {{ phone | addStar }}
        </span>
      </p>
      <p class="hint" v-show="!checkWay">
        使用邮箱验证身份，现在邮箱：<span class="blue">
          {{ mail | addStar("mail") }}
        </span>
      </p>
      <el-form :model="updatePswForm" ref="updatePswForm" :rules="rules">
        <!-- 欺骗浏览器填充 -->
        <input type="text" name="phone" class="deceit" autocomplete="on" />
        <input
          type="password"
          name="password"
          class="deceit"
          autocomplete="on"
        />
        <el-form-item prop="captcha">
          <el-input
            v-model="updatePswForm.captcha"
            placeholder="请输入验证码"
            autocomplete="new-password"
          >
            <el-button
              slot="suffix"
              @click="sendCaptcha(5)"
              type="text"
              class="inputSuffix"
              :loading="timeRemaining == 60 && !allow"
              :disabled="!allow"
            >
              {{
                timeRemaining == 60 ? "获取验证码" : "重新获取" + timeRemaining
              }}
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="updatePswForm.password"
            :type="isShowPsw ? 'text' : 'password'"
            placeholder="请输入您的密码"
            minlength="6"
            maxlength="25"
            autocomplete="new-password"
          >
            <i
              slot="suffix"
              @click="isShowPsw = !isShowPsw"
              :class="[
                'iconfont',
                'showPsw',
                isShowPsw ? 'icon-a-kejianicon1x' : 'icon-a-bukejianicon1x',
              ]"
            ></i>
          </el-input>
        </el-form-item>
      </el-form>
    </section>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="text"
        class="clearMargenPadding"
        v-if="phone && mail"
        @click="switchCheckWay"
      >
        {{ checkWay ? "通过邮箱验证" : "通过手机验证" }}
      </el-button>
      <div>
        <el-button size="medium" @click="cancel">取 消</el-button>
        <el-button
          size="medium"
          type="primary"
          @click="submit"
          :loading="subLoading"
        >
          确 定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { resetPsw } from "../../../api/accountManage";
import { pswVerify } from "../../../tool";
export default {
  props: {
    updatePsw: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      isShowPsw: false, // 是否显示密码
      updatePswForm: {
        username: null,
        captcha: null,
        password: null,
      },
      rules: {
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ validator: pswVerify, trigger: "blur" }],
      },
      subLoading: false,
      checkWay: true,
    };
  },
  computed: {
    ...mapGetters(["allow", "phone", "mail", "timeRemaining", "captchaKey"]),
  },
  watch: {
    updatePsw(val) {
      this.show = val;
    },
  },
  methods: {
    ...mapActions(["getCaptcha", "logout"]),
    open() {
      if (this.mail) {
        this.checkWay = false;
      } else {
        this.checkWay = true;
      }
    },
    // 取消
    cancel() {
      this.$refs["updatePswForm"].resetFields();
      this.show = false;
      this.$emit("update:updatePsw", false);
    },
    // 切换验证方式
    switchCheckWay() {
      // if (!this.mail) {
      //   this.$message({ type: "warning", message: "未绑定邮箱" })
      //   return
      // } else if (!this.phone) {
      //   this.$message({ type: "warning", message: "未绑定手机号" })
      //   return
      // }
      this.$store.commit("RESET_SMS");
      this.checkWay = !this.checkWay;
    },
    // 发送验证码
    async sendCaptcha() {
      let params;
      if (this.checkWay) {
        params = {
          type: 3,
          captcha: "phone",
        };
        this.updatePswForm.username = this.phone;
      } else {
        params = {
          type: 15,
          captcha: "mail",
        };
        this.updatePswForm.username = this.mail;
      }
      await this.getCaptcha(params);
    },
    // 修改密码提交
    async submit() {
      if (!this.updatePswForm.username) {
        this.$message.error("请先获取验证码");
        return;
      }
      this.$refs["updatePswForm"].validate(async (valid) => {
        if (valid) {
          let res = await resetPsw({
            ...this.updatePswForm,
            captchaKey: this.captchaKey,
          }).catch();
          if (res.code === 1) {
            this.$message.success("修改密码成功");
            this.$emit("update:updatePsw", false);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.deceit {
  position: absolute;
  left: -99999px;
}
.showPsw {
  padding-right: 16px;
  line-height: 48px;
  cursor: pointer;
}
</style>
